module.exports = require("./fr-SC");